import { useState, useEffect } from 'react'
import { Button } from '@/components/ui/button'
import { Card } from '@/components/ui/card'

const COOKIE_CONSENT_KEY = 'cookie-consent'

export function CookieConsent() {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const preference = localStorage.getItem(COOKIE_CONSENT_KEY)
    if (!preference) {
      // Small delay so it animates in
      const timer = setTimeout(() => setVisible(true), 500)
      return () => clearTimeout(timer)
    }
  }, [])

  const handleConsent = (value: 'accepted' | 'declined') => {
    localStorage.setItem(COOKIE_CONSENT_KEY, value)
    setVisible(false)
  }

  if (!visible) return null

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 animate-in slide-in-from-bottom duration-300">
      <Card className="mx-auto max-w-2xl p-4 shadow-lg border bg-card">
        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
          <p className="text-sm text-muted-foreground flex-1">
            We use cookies to improve your experience. By continuing, you agree to our cookie policy.
          </p>
          <div className="flex gap-2 shrink-0">
            <Button
              variant="ghost"
              size="sm"
              onClick={() => handleConsent('declined')}
            >
              Decline
            </Button>
            <Button
              size="sm"
              onClick={() => handleConsent('accepted')}
            >
              Accept
            </Button>
          </div>
        </div>
      </Card>
    </div>
  )
}
